"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var address_1 = require("bitcoinjs-lib/src/address");
var bech32 = __importStar(require("bech32"));
var types_1 = require("../types");
var base_1 = __importDefault(require("./base"));
// Todo copy paste from bitcoin.ts. we can merge them later
var Litecoin = /** @class */ (function (_super) {
    __extends(Litecoin, _super);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Litecoin(_a) {
        var network = _a.network;
        var _this = _super.call(this, { network: network }) || this;
        _this.network.dustThreshold = 10000;
        _this.network.dustPolicy = "FIXED";
        _this.network.usesTimestampedTransaction = false;
        return _this;
    }
    // infer address type from its syntax
    Litecoin.prototype.getDerivationMode = function (address) {
        if (address.match("^(ltc1).*")) {
            return types_1.DerivationModes.NATIVE_SEGWIT;
        }
        if (address.match("^(3|2|M).*")) {
            return types_1.DerivationModes.SEGWIT;
        }
        if (address.match("^(1|n|m|L).*")) {
            return types_1.DerivationModes.LEGACY;
        }
        throw new Error("INVALID ADDRESS: ".concat(address).concat(" is not a valid address"));
    };
    Litecoin.prototype.toOutputScript = function (address) {
        return (0, address_1.toOutputScript)(address, this.network);
    };
    // eslint-disable-next-line class-methods-use-this
    Litecoin.prototype.validateAddress = function (address) {
        // bech32 address
        if (address.substring(0, 3) === "ltc") {
            if (bech32.decodeUnsafe(address)) {
                return true;
            }
        }
        // bs58 address
        return _super.prototype.validateAddress.call(this, address);
    };
    return Litecoin;
}(base_1["default"]));
exports["default"] = Litecoin;
//# sourceMappingURL=litecoin.js.map